export default __webpack_public_path__ + "static/media/tools.85af59d2.jpg";